<template>
<div>
    <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_bill_retrospect_all">
                <img src="@/assets/icon-restaurant-bill.png">
            </div>
            <h2 class="title_bill_retrospect_all">บิลย้อนหลังทั้งหมด</h2>
        </div>

        <v-btn class="grad-primary-bg white--text titlefont_bill_retrospect_all" height="50" width="20%" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn>
    </div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show === true">ยกเลิกบิลเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="message_remove_money_in_out === true">ยกเลิกเงินเข้าเรียบร้อยแล้ว</v-alert>
        <v-alert type="warning" class="alert_success" v-if="alert_waiting === true">กำลังทำการพิมพ์ใบเสร็จกรุณารอสักครู่...</v-alert>
    </v-slide-x-reverse-transition>

    <v-card>
        <v-tabs grow>
            <v-tab @click="changePage(1)">รายการบิลย้อนหลังทั้งหมด</v-tab>
            <v-tab @click="changePage(2)">รายการรับเงินเข้าทั้งหมด</v-tab>
        </v-tabs>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
       
            <div v-if="page_next === 1">

                <div class="pa-4">
                    <div class="d-flex justify-space-between align-center">
                        <div class="startdate_sale_statistic mr-1">
                        <v-menu ref="menu_start_date" v-model="menu_start_date" :close-on-content-click="false" :return-value.sync="start_date" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="start_date_be" label="วันที่เริ่ม (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="start_date" :max="end_date" no-title scrollable locale="th" :events="dateStartEndBE('start_date')">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="searchDate('start_date')">
                                ตกลง
                            </v-btn>
                            <v-btn text color="primary" @click="menu_start_date = false">
                                ยกเลิก
                            </v-btn>
                            </v-date-picker>
                        </v-menu>
                        </div>

                        <div class="enddate_sale_statistic ml-1">
                        <v-menu ref="menu_end_date" v-model="menu_end_date" :close-on-content-click="false" :return-value.sync="end_date" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="end_date_be" label="วันที่สิ้นสุด (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="end_date" :min="start_date" no-title scrollable locale="th" :events="dateStartEndBE('end_date')">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="searchDate('end_date')">
                                ตกลง
                            </v-btn>
                            <v-btn text color="primary" @click="menu_end_date = false">
                                ยกเลิก
                            </v-btn>
                            </v-date-picker>
                        </v-menu>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 d-flex justify-center">
                    <v-btn color="#1094C7" class="white--text titlefont_poslist mx-2" type="submit" height="50" @click="exportPDFInvoices">
                        ดาวน์โหลดรายงาน ไฟล์ PDF
                    </v-btn>

                    <v-btn color="#28ab28" class="white--text titlefont_poslist mx-2" type="submit" height="50" @click="exportExcelInvoices">
                        ดาวน์โหลดรายงาน ไฟล์ Excel
                    </v-btn>
                </div>

                <v-card-title>
                    <v-text-field v-model="bill_search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">เลขที่ใบเสร็จ</th>
                                <th class="text-left"> วัน-เวลา </th>
                                <th class="text-left"> ประเภท </th>
                                <th class="text-left"> ผู้ดำเนินการ </th>
                                <th class="text-left"> ยอดขาย </th>
                                <th class="text-left"> การชำระเงิน </th>
                                <th class="text-left"> สถานะ </th>
                                <th class="text-left"> ดูรายละเอียด </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dataDetail, key_history) in bill_list" :key="key_history" >
                                <td>{{dataDetail.invoin_code}}</td>
                                <td>{{dataDetail.date}}</td>
                                <td>{{dataDetail.type}} <span v-if="dataDetail.table_no != 'สั่งกลับบ้าน'">(โต๊ะ {{ dataDetail.table_no }})</span></td>
                                <td>{{dataDetail.user_cancel}}</td>
                                <td>{{ Intl.NumberFormat().format(dataDetail.total_price)}}</td>
                                <td :class="dataDetail.payment_method == 'สด' ? 'success--text': dataDetail.payment_method == 'โอน' || dataDetail.payment_method == 'เดรบิต/เครดิต' ? 'warning--text' : dataDetail.payment_method == 'โครงการรัฐ' ? 'primary--text' : ''">{{dataDetail.payment_method}}</td>
                                <td>
                                    <div v-if="$store.state.userProfile.pre_cancel_bill == 1">
                                        <v-btn color="error" v-if="dataDetail.status == 'ยกเลิกบิล'" @click="confirmBill(dataDetail.id,dataDetail.invoin_code)">{{ dataDetail.status }}</v-btn>
                                        <div class="error--text" v-if="dataDetail.status == 'บิลถูกยกเลิก'">{{ dataDetail.status }}</div>
                                    </div>
                                    <div v-else>
                                        <v-btn color="gray" v-if="dataDetail.status == 'ยกเลิกบิล'">{{ dataDetail.status }}</v-btn>
                                    </div>
                                </td>
                                <td>
                                    <span class="detail_bill_retrospect_all" @click="detailBill(dataDetail.id)">
                                        <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <div class="text-center mt-5 mb-5" v-if="page != null">
                    <v-pagination class="pb-3" v-model="page" :length="page_all" :total-visible="7"
                        color="#55c0e9"></v-pagination>
                </div>
            </div>
            <div v-if="page_next === 2">

                <div class="pa-4">
                    <div class="d-flex justify-space-between align-center">
                        <div class="startdate_sale_statistic mr-1">
                        <v-menu ref="menu_start_date" v-model="menu_start_date" :close-on-content-click="false" :return-value.sync="start_date" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="start_date_be" label="วันที่เริ่ม (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="start_date" :max="end_date" no-title scrollable locale="th" :events="dateStartEndBE('start_date')">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="searchDate('start_date')">
                                ตกลง
                            </v-btn>
                            <v-btn text color="primary" @click="menu_start_date = false">
                                ยกเลิก
                            </v-btn>
                            </v-date-picker>
                        </v-menu>
                        </div>

                        <div class="enddate_sale_statistic ml-1">
                        <v-menu ref="menu_end_date" v-model="menu_end_date" :close-on-content-click="false" :return-value.sync="end_date" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="end_date_be" label="วันที่สิ้นสุด (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="end_date" :min="start_date" no-title scrollable locale="th" :events="dateStartEndBE('end_date')">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="searchDate('end_date')">
                                ตกลง
                            </v-btn>
                            <v-btn text color="primary" @click="menu_end_date = false">
                                ยกเลิก
                            </v-btn>
                            </v-date-picker>
                        </v-menu>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 d-flex justify-center">
                    <v-btn color="#1094C7" class="white--text titlefont_poslist mx-2" type="submit" height="50" @click="exportPDFMonInOut">
                        ดาวน์โหลดรายงาน ไฟล์ PDF
                    </v-btn>

                    <v-btn color="#28ab28" class="white--text titlefont_poslist mx-2" type="submit" height="50" @click="exportExcelMonInOut">
                        ดาวน์โหลดรายงาน ไฟล์ Excel
                    </v-btn>
                </div>

                <v-card-title>
                    <v-text-field v-model="money_search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="money_headers" :items="money_list" :search="money_search">
                    <template v-slot:item="dataDetail">
                        <tr>
                            <td>{{dataDetail.item.name == null || '' ? '-' : dataDetail.item.name}}</td>
                            <td>{{dataDetail.item.created_at}}</td>
                            <td>{{dataDetail.item.price}}</td>
                            <td v-if="dataDetail.item.status_delete === 0" :class="dataDetail.item.status === 'เงินสด' ? 'success--text' : ''" :style="dataDetail.item.status === 'เงินโอน' ? 'color:#2f4f4f;' : ''">{{dataDetail.item.status}}</td>
                            <td v-if="dataDetail.item.status_delete === 0">{{dataDetail.item.description}}</td>
                            <td v-if="dataDetail.item.status_delete === 1" class="error--text">{{ dataDetail.item.status }}</td>
                            <td v-if="dataDetail.item.status_delete === 1">{{dataDetail.item.description}}</td>
                            <td>
                                <v-btn color="error" v-if="dataDetail.item.status_delete == 0" @click="cancelMoneyInOut(dataDetail.item.id)">{{dataDetail.item.action}}</v-btn>
                                <div class="error--text" v-if="dataDetail.item.status_delete == 1">{{dataDetail.item.action}}</div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </div>
    </v-card>
    <v-dialog v-model="confirm_bill" persistent max-width="600">
        <div v-if="loading_page_detail === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>

        <v-card v-if="loading_page_detail === false">
            <v-form ref="form_successbill" @submit.prevent="successBill()">
                <v-card-title>
                    คำเตือน
                </v-card-title>
                <v-card-text>
                    <div class="mb-2">
                        ต้องการยกเลิกบิล {{ bill_invoin_code }} ใช่หรือไม่ ?
                    </div>
                    <div class="mb-2">
                        <v-select label="เหตุผลในการยกเลิกบิล" v-model="bill_description" :items="$store.state.reasonCancelBill" color="primary" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกเหตุผลในการยกเลิกบิล']" @change="billCancelDescription()" required outlined>
                        </v-select>
                    </div>
                    <div class="mb-2" v-if="bill_description_reason_check">
                        <v-text-field v-model="bill_description_reason" color="primary" label="เหตุผลในการยกเลิกบิล" :rules="[v => !!v || 'กรุณากรอกเหตุผลในการยกเลิกบิล']" required outlined></v-text-field>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" type="submit">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" @click="cancelBill()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <v-dialog v-model="detail_bill" persistent max-width="600">
        <div v-if="loading_page_detail_bill === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_detail_bill === false">
            <v-card-title class="justify-end">
                <div class="cursor_bill_retrospect_all" @click="detail_bill = false">
                    <v-icon>mdi-close</v-icon>
                </div>
            </v-card-title>
            <v-card-text>
                <h2 class="mb-2 error--text" v-if="data_bill_detail.description_delete">
                    หมายเหตุในการยกเลิกบิล ?
                </h2>
                <h2 class="mb-2 error--text" v-if="data_bill_detail.description_delete">
                    ** {{ data_bill_detail.description_delete }} **
                </h2>
                <div class="report_bill_retrospect_all">
                    <div class="d-flex justify-space-between">
                        <div class="img_report_bill_retrospect_all">
                            <img :src="data_bill_detail.logo_image">
                        </div>
                        <div class="header_report_bill_retrospect_all">
                            <div>{{ data_bill_detail.name_bill }}</div>
                            <div>{{ data_bill_detail.address_bill }}</div>
                            <div>โทร. {{ data_bill_detail.tel_bill }}</div>
                        </div>
                    </div>
                    <div class="text-right">เลขที่ {{ data_bill_detail.code }}</div>
                    <div class="text-center" style="margin-top: -21px">ใบกำกับภาษีอย่างย่อ</div>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    อาหาร
                                </th>
                                <th class="text-left">
                                    จำนวน
                                </th>
                                <th class="text-right">
                                    รวม
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail_buffet,key) in data_bill_buffet" :key="key">
                                <td class="text-left">
                                    {{ detail_buffet.name }} ({{ detail_buffet.price }})
                                </td>
                                <td class="text-left">
                                    {{ detail_buffet.amount }}
                                </td>
                                <td class="text-right">
                                    {{ detail_buffet.total_price }}
                                </td>
                            </tr>

                            <tr v-for="(detail_nobuffet,key) in data_bill_nobuffet" :key="key">
                                <td class="text-left">
                                    <div>
                                        {{ detail_nobuffet.name }} ({{ detail_nobuffet.price }})
                                    </div>
                                    <div v-if="detail_nobuffet.extra">
                                        <div v-for="(detail_nobuffet_list,key) in detail_nobuffet.topping_list" :key="key">
                                             - {{ detail_nobuffet_list.topping_name }} ({{ detail_nobuffet_list.price }})
                                        </div>
                                    </div>
                                </td>
                                <td class="text-left">
                                    {{ detail_nobuffet.amount }}
                                </td>
                                <td class="text-right">
                                    {{ detail_nobuffet.total_price }}
                                </td>
                            </tr>
                        
                            <tr v-if="data_bill_detail.vat_price !== 0 && data_bill_detail.vat_price !== undefined">
                        
                                <td class="text-right" colspan="2">
                                    ราคาก่อนภาษี
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.price }}
                                </td>
                            </tr> 
                            <tr v-else>
                                <td class="text-right" colspan="2">
                                    รวมเงิน
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.price }}
                                </td>
                            </tr>   
                           <!-- แสดงแถว vat 7% ก็ต่อเมื่อ vat_price มีค่า -->
                                <tr v-if="data_bill_detail.vat_price !== 0 && data_bill_detail.vat_price !== undefined">
                                    <td class="text-right" colspan="2">
                                        vat 7%
                                    </td>
                                    <td class="text-right">
                                        {{ data_bill_detail.vat_price }}
                                    </td>
                                </tr>
                                <tr v-else></tr>

                                <tr  v-if="data_bill_detail.vat_price !== 0 && data_bill_detail.vat_price !== undefined">
                                <td class="text-right" colspan="2">
                                    ราคารวมภาษีมูลค่าเพิ่ม
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.total_price}}
                                </td>
                            </tr>
                                <tr v-else>
                                <td class="text-right" colspan="2">
                                    ยอดรวม
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.price }}
                                </td>
                                </tr>
                                <!-- แสดงแถวค่าบริการ ก็ต่อเมื่อ percen_service_charge และ service_charge มีค่า -->
                                <tr v-if="data_bill_detail.percen_service_charge !== null && data_bill_detail.percen_service_charge !== undefined && data_bill_detail.service_charge !== null && data_bill_detail.service_charge !== undefined">
                                    <td class="text-right" colspan="2">
                                        ค่าบริการ {{ data_bill_detail.percen_service_charge }}%
                                    </td>
                                    <td class="text-right">
                                        {{ data_bill_detail.service_charge }}
                                    </td>
                                </tr>
                             <tr>
                                <td class="text-right" colspan="2">
                                    ส่วนลด
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.discount }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="2">
                                    รวมทั้งสิ้น
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.total_price }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="2">
                                    เงินที่จ่าย
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.reccive_money }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="2">
                                    เงินทอน
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.change }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <div>
                    <v-btn dark class="white--text" width="100%" height="50" @click="open_confirm_print = true">พิมพ์ใบเสร็จ</v-btn>
                    <v-btn color="#55c0e9" class="white--text mt-6" width="100%" height="50" @click="open_confirm_print_tax = true">พิมพ์ใบกำกับภาษีฉบับเต็ม</v-btn>
                </div>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="alert_money_in_out" persistent max-width="600">
        <v-card>
            <v-form ref="form_remove_money_in_out" @submit.prevent="removeMoney_in_out()">
                <v-card-title>
                    ต้องการลบ
                </v-card-title>

                <v-card-text>
                    <div class="mb-2">
                        ต้องการลบ เงินเข้า/เงินออก นี้ใช่หรือไม่ ??
                    </div>
                    <div class="mb-2">
                        <v-select label="เหตุผลในการยกเลิกเงินเข้า/เงินออก" v-model="remove_money_in_out_description" :items="$store.state.reasonCancelBill" color="primary" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกเหตุผลในการยกเลิกเงินเข้า/เงินออก']" @change="removeMoneyInOutDescription()" required outlined>
                        </v-select>
                    </div>
                    <div class="mb-2" v-if="remove_money_in_out_reason_check">
                        <v-text-field v-model="remove_money_in_out_reason" color="primary" label="เหตุผลในการยกเลิกบิล" :rules="[v => !!v || 'กรุณากรอกเหตุผลในการยกเลิกเงินเข้า/เงินออก']" required outlined></v-text-field>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" type="submit">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" @click="alert_money_in_out = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <v-dialog v-model="open_confirm_print" persistent max-width="600">
        <v-card>
            <v-form @submit.prevent="printBill()">
                <v-card-title>
                    ต้องการลบ
                </v-card-title>

                <v-card-text>
                    <div class="mb-2">
                        ต้องการพิมพ์ใบเสร็จ นี้ใช่หรือไม่ ??
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" type="submit">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" @click="open_confirm_print = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <v-dialog v-model="open_confirm_print_tax" persistent max-width="600">
        <v-card>
            <v-form @submit.prevent="printTax(tax_id)">
                <v-card-title>
                    ยืนยันการพิมพ์ใบกำกับภาษี
                </v-card-title>

                <v-card-text>
                    <div class="mb-2">
                        ต้องการพิมพ์ใบกำกับภาษี นี้ใช่หรือไม่ ??
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn color="#28ab28" class="white--text" type="submit">
                            ตกลง
                        </v-btn>
                    <v-btn color="error" @click="open_confirm_print_tax = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    <NotFoundDialog v-model="dialogVisible" @retry="clearSearch"/>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import NotFoundDialog from "@/components/menuadmin/NotFoundDialog.vue";
import before_image from "@/assets/ZoftConnect_Logo_Black_for_Bill_150px.png";
export default {
    name: 'billretrospect',
    components: {
        NotFoundDialog,
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_page_detail: true,
            loading_page_detail_bill: true,
            menu_start_date: false,
            menu_end_date: false,
            start_date_be: '',
            start_date: '',
            end_date_be: '',
            end_date: '',
            page_next: 1,
            page: 1,
            page_all: 1,
            size:10,
            page_null: null,
            alert_show: false,
            alert_waiting: false,
            confirm_bill: false,
            bill_id: null,
            bill_description: null,
            bill_description_reason_check: false,
            bill_description_reason: null,
            bill_invoin_code: null,
            detail_bill: false,
            data_bill_detail: {
                logo_image: before_image,
                name_bill: null,
                address_bill: null,
                tel_bill: null,
                code: null,
                price: null,
                discount: null,
                total_price: null,
                reccive_money: null,
                change: null,
            },
            data_bill_buffet: [],
            data_bill_nobuffet: [],
            bill_search: '',
            bill_headers: [{
                    text: 'เลขที่ใบเสร็จ',
                    align: 'start',
                    value: 'invoin_code',
                },
                {
                    text: 'วัน-เวลา',
                    align: 'date',
                    value: 'date'
                },
                {
                    text: 'ประเภท',
                    value: 'type'
                },
                {
                    text: 'ผู้ดำเนินการ',
                    value: 'user_cancel'
                },
                {
                    text: 'ยอดขาย',
                    value: 'total_price'
                },
                {
                    text: 'การชำระเงิน',
                    value: 'payment_method'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'ดูรายละเอียด',
                    value: 'action'
                },
            ],
            bill_list: [],
            money_search: '',
            money_headers: [{
                    text: 'รายการ',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'วัน-เวลา',
                    align: 'date',
                    value: 'date'
                },
                {
                    text: 'ราคา',
                    value: 'price'
                },
                {
                    text: 'การชำระเงิน',
                    value: 'status'
                },
                {
                    text: 'หมายเหตุ',
                    value: 'description'
                },
                {
                    text: 'สถานะ',
                    value: 'action'
                },
            ],
            money_list: [],
            alert_money_in_out: false,
            remove_money_in_out_description: null,
            remove_money_in_out_reason_check: null,
            remove_money_in_out_reason: null,
            message_remove_money_in_out: false,
            open_confirm_print: false,
            open_confirm_print_tax: false,
            tax_id: null,
            print_id: null,
            currentPage:1,
            dialogVisible:false
        }
    },
    methods: {
        async changePage(type) {
            this.page_next = type
            if (type === 1) {
                this.currentPage = 1
                this.billList()
            }
            if (type === 2) {
                this.currentPage = 2
                this.moneyInOutList()
            }
        },
        async billList() {
            // this.loading_page = true
            HTTP.post(`/POS/table/invoice-all?page=${this.page}&size=${this.size}&search=${this.bill_search}`,{'first_date':this.start_date,'end_date':this.end_date}, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bill_list = response.data.invoiceList
                        response.data.invoiceList.forEach((detail, index) => {
                            if (detail.payment_method == 0) this.bill_list[index].payment_method = 'สด'
                            else if (detail.payment_method == 1) this.bill_list[index].payment_method = 'โอน'
                            else if (detail.payment_method == 2) this.bill_list[index].payment_method = 'โครงการรัฐ'
                            else if (detail.payment_method == 3) this.bill_list[index].payment_method = 'เดรบิต/เครดิต'
                            else this.bill_list[index].payment_method = '-'
                            this.bill_list[index].status = detail.status == 0 ? 'ยกเลิกบิล' : 'บิลถูกยกเลิก'
                        })

                        if (this.bill_search) {
                            this.page = 1
                            this.page_all = 1
                            this.size = 50
                        }else{
                            this.page = response.data.current_page ? parseFloat(response.data.current_page) : null
                            this.page_all = response.data.pages ? response.data.pages : 1
                            this.size = 10
                        }
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async moneyInOutList() {
            this.loading_page = true
            HTTP.post('/moninoutall',{'first_date':this.start_date,'end_date':this.end_date}, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.money_list = response.data.monInout
                        response.data.monInout.forEach((detail, index) => {
                            if (detail.status_delete == 0) {
                                this.money_list[index].status = detail.status === 1 ? 'เงินโอน' : 'เงินสด'
                                this.money_list[index].description = detail.description == null ? '-' : detail.description
                                this.money_list[index].action = 'ยกเลิกรายการ'
                            }
                            if (detail.status_delete == 1) {
                                this.money_list[index].status = 'ยกเลิก'
                                this.money_list[index].description = detail.description_delete == null ? '-' : detail.description_delete
                                this.money_list[index].action = 'รายการถูกยกเลิก'
                            }
                        })
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async cancelMoneyInOut(id) {
            this.alert_money_in_out = true
            this.money_in_out_delete_id = id
        },
        async removeMoneyInOutDescription() {
            this.remove_money_in_out_reason_check = false
            if (this.remove_money_in_out_description == 'อื่นๆ') {
                this.remove_money_in_out_reason_check = true
            }
        },
        async removeMoney_in_out() {
            if (this.$refs.form_remove_money_in_out.validate()) {
                this.alert_money_in_out = false
                this.loading_page_money_in_out = true
                let cancel_description = this.remove_money_in_out_description
                if (this.remove_money_in_out_reason_check) {
                    cancel_description = this.remove_money_in_out_reason
                }
                HTTP.post('/POS/money-in-outs-delete', {
                        id: this.money_in_out_delete_id,
                        description_delete: cancel_description,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.money_in_out_delete_id = null
                            this.remove_money_in_out_description = null
                            this.message_remove_money_in_out = true
                            setTimeout(() => this.message_remove_money_in_out = false, 5000)
                            this.moneyInOutList()
                        }

                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })

            }
        },
        async confirmBill(id, invoin_code) {
            this.loading_page_detail = true
            this.bill_id = id
            this.bill_invoin_code = invoin_code
            this.bill_description = null
            this.loading_page_detail = false
            this.confirm_bill = true
        },
        async cancelBill() {
            this.bill_id = null
            this.bill_invoin_code = null
            this.bill_description = null
            this.bill_description_reason_check = false
            this.bill_description_reason = null
            this.confirm_bill = false
        },
        async billCancelDescription() {
            this.bill_description_reason_check = false
            if (this.bill_description == 'อื่นๆ') {
                this.bill_description_reason_check = true
            }
        },
        async successBill() {
            if (this.$refs.form_successbill.validate()) {
                this.loading_page_detail = true
                let cancel_description = this.bill_description
                if (this.bill_description_reason_check) {
                    cancel_description = this.bill_description_reason
                }
                HTTP.post('/POS/table/invoice-update-status', {
                        id: this.bill_id,
                        description: cancel_description
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.confirm_bill = false
                            this.billList()
                            this.alert_show = true
                            setTimeout(() => this.alert_show = false, 5000)
                        }

                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
        },
        async detailBill(id) {
            this.loading_page_detail_bill = true
            this.detail_bill = true
            this.data_bill_detail = {
                logo_image: before_image,
                name_bill: null,
                address_bill: null,
                tel_bill: null,
                code: null,
                price: null,
                discount: null,
                total_price: null,
                reccive_money: null,
                change: null,
                description_delete: null,

            }
            this.data_bill_buffet = []
            this.data_bill_nobuffet = []
            this.print_id = id
            this.tax_id = id
            HTTP.get('/POS/table/invoice-detaile/' + id, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.data_bill_detail = response.data.invoiceDetaile
                        this.data_bill_buffet = response.data.listBuffet
                        this.data_bill_nobuffet = response.data.listnoBuffet
                        this.loading_page_detail_bill = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async printBill() {
            this.open_confirm_print = false
            HTTP.post('/printlastagain/' + this.print_id, null, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.print_id = null
                        this.alert_waiting = true
                        setTimeout(() => this.alert_waiting = false, 5000)
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async printTax(id) {
            this.open_confirm_print_tax = false
            this.$router.push(`/createtaxinvoice/${id}`)
        },
        async searchDate(type) {
            if (type == 'start_date') {
                this.$refs.menu_start_date.save(this.start_date)
                let date_arr = this.start_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.start_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_start_date = false
            }
            if (type == 'end_date') {
                this.$refs.menu_end_date.save(this.end_date)
                let date_arr = this.end_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.end_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_end_date = false
            }
            if (this.currentPage === 1) {
                this.billList()
            }
            if (this.currentPage === 2) {
                this.moneyInOutList()
            }
        },
        dateStartEndBE(type) {
            if (type == 'start_date') {
                if (this.start_date == '') {
                this.start_date_be = ''
                }
                if (this.start_date) {
                let date_arr = this.start_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.start_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'end_date') {
                if (this.end_date == '') {
                this.end_date_be = ''
                }
                if (this.end_date) {
                let date_arr = this.end_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.end_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
        },
        exportExcelInvoices(){
                HTTP.post('/POS/export-invoices-excel', {date_start:this.start_date,date_end:this.end_date},{

                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        },
                        responseType: 'blob'
                    })
                    .then((response) => {
                        if (response.status == 200) {
                        

                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const downloadLink = document.createElement('a');
                            downloadLink.href = url;
                            downloadLink.setAttribute('download', 'invoices.xlsx');
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                        }

                    })
                    .catch((error) => {
                        if(error.response.status === 404){
                            this.dialogVisible = true;
                        }
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
        },
        exportExcelMonInOut(){
                HTTP.post('/POS/export-moninout-excel', {date_start:this.start_date,date_end:this.end_date},{

                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        },
                        responseType: 'blob'
                    })
                    .then((response) => {
                        if (response.status == 200) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const downloadLink = document.createElement('a');
                            downloadLink.href = url;
                            downloadLink.setAttribute('download', 'money_in_out.xlsx');
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                        }

                    })
                    .catch((error) => {
                        if(error.response.status === 404){
                            this.dialogVisible = true;
                        }
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
        },
        exportPDFInvoices(){
                HTTP.post('/POS/export-invoices-pdf', {date_start:this.start_date,date_end:this.end_date},{

                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        },
                        responseType: 'blob'
                    })
                    .then((response) => {
                        if (response.status == 200) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const downloadLink = document.createElement('a');
                            downloadLink.href = url;
                            downloadLink.setAttribute('download', 'money_in_out.pdf');
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                        }

                    })
                    .catch((error) => {
                        if(error.response.status === 404){
                            this.dialogVisible = true;
                        }
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
        },
        exportPDFMonInOut(){
                HTTP.post('/POS/export-moninout-pdf', {date_start:this.start_date,date_end:this.end_date},{

                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        },
                        responseType: 'blob'
                    })
                    .then((response) => {
                        if (response.status == 200) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const downloadLink = document.createElement('a');
                            downloadLink.href = url;
                            downloadLink.setAttribute('download', 'money_in_out.pdf');
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                        }

                    })
                    .catch((error) => {
                        if(error.response.status === 404){
                            this.dialogVisible = true;
                        }
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
        },
        clearSearch(is_retry){            
            if(is_retry){
                this.dialogVisible = false
                this.start_date = ''
                this.end_date = ''
                if (this.currentPage === 1) {
                    this.billList()
                }
                if (this.currentPage === 2) {
                    this.moneyInOutList()
                }
            }
        }

    },
    mounted() {
        this.billList()
    },
    watch: {
        page() {
            this.billList()
        },
        bill_search() {
            this.billList()
        }
    }
}
</script>
